export default __webpack_public_path__ + "static/media/B0002.5ab7f29f.png";